import { cloneDeepWith, isEqualWith, isFunction, isString } from 'lodash-es';
// eslint-disable-next-line import/no-cycle
import { Presenter } from '../../app/presenters/presenter';

export function clone(value) {
    return cloneDeepWith(value, element => {
        if (element instanceof Presenter) {
            return null;
        }
    });
}

export function isDefined(...elements) {
    for (const el of elements) {
        if (el === undefined) {
            return false;
        }
    }

    return true;
}

export function isPresent(...elements) {
    for (const el of elements) {
        if (el === undefined || el === null) {
            return false;
        }
    }

    return true;
}

export function isAnyPresent(...elements) {
    for (const el of elements) {
        if (Number.isNaN(el)) {
            continue;
        }

        if (el !== undefined && el !== null) {
            return true;
        }
    }

    return false;
}

/**
 * @param original
 * @param other
 * @param {boolean} ignoreNull
 * @return {boolean}
 */
export function equals(original, other, { ignoreEmpty = false } = {}) {
    function isEmpty(value) {
        return value === null || value === undefined || ((isString(value) || Array.isArray(value)) && !value.length);
    }

    return isEqualWith(original, other, function(a, b, key) {
        if ((isString(key) && key.charAt(0) === '$') || (isFunction(a) && isFunction(b))) {
            return true;
        }

        if (key === '$presenter' || a instanceof Presenter) {
            return true;
        }

        if (ignoreEmpty && isEmpty(a) && isEmpty(b)) {
            return true;
        }
    });
}

/**
 * @param {string} value
 * @return {?string}
 */
export function mimeType(value) {
    if (!value) {
        return value;
    }

    if (value.substr(0, 6) === 'image/') {
        return 'Image';
    }

    if (value.substr(0, 6) === 'video/') {
        return 'Video';
    }

    switch (value) {
        case null:
            return 'Unknown file type';

        case 'application/vnd.ms-outlook':
        case 'message/rfc822':
            return 'Email';

        case 'application/vnd.ms-office':
            return 'Office Document';

        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'Word Document';

        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'Excel Spreadsheet';

        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'Powerpoint Presentation';

        case 'application/pdf':
            return 'PDF Document';
    }

    return null;
}
